@import '../../../../../../../../../../constants/spacing.module.less';

.inventory-setup-content {
  text-align: left;
  margin-top: @space-24;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  overflow: hidden;
  padding: @space-16;
  background: var(--white);
}
